"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Calendar, ShieldCheck } from "lucide-react";
declare global {
  interface Window {
    Calendly?: {
      initPopupWidget: (options: {
        url: string;
      }) => void;
    };
  }
}
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  useEffect(() => {
    const calendlyCssHref = "https://assets.calendly.com/assets/external/widget.css";
    const calendlyScriptSrc = "https://assets.calendly.com/assets/external/widget.js";
    if (!document.querySelector(`link[href="${calendlyCssHref}"]`)) {
      const link = document.createElement("link");
      link.href = calendlyCssHref;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    if (!document.querySelector(`script[src="${calendlyScriptSrc}"]`)) {
      const script = document.createElement("script");
      script.src = calendlyScriptSrc;
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  const handleCalendlyClick = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/mfloresdo/30min"
      });
    }
  };
  return <section className="pt-10 pb-10 px-4 sm:px-6 lg:px-8 bg-background overflow-hidden">
      <div className="container max-w-4xl mx-auto">
        <div ref={ref} className={`text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex max-w-full items-center gap-2 rounded-full border border-primary/30 bg-primary-light-bg px-3 py-1.5 sm:px-4 sm:py-2 mb-5">
            <ShieldCheck className="w-4 h-4 text-primary flex-shrink-0" />
            <span className="text-xs sm:text-sm font-semibold text-primary leading-snug">
              Basecamp TRT — $150/month
            </span>
          </div>

          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-5 sm:mb-6 leading-tight">
            Stop Guessing. Find Out If Low Testosterone Is Part of the Problem.
          </h2>

          <p className="text-base sm:text-lg text-muted-dark mb-7 sm:mb-8 max-w-2xl mx-auto leading-relaxed">
            Schedule a free 30-minute consultation with Dr. Flores to review
            your symptoms, discuss appropriate labs, and determine whether
            physician-led TRT may be clinically appropriate for you.
          </p>

          <Button size="lg" className="w-full max-w-[340px] sm:w-auto sm:max-w-none mx-auto bg-accent text-accent-foreground hover:bg-accent-hover active:bg-accent-active shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-4 sm:px-8 py-4 sm:py-6 min-h-12 sm:min-h-14 text-sm sm:text-lg font-semibold rounded-md hover:-translate-y-1 inline-flex items-center justify-center gap-2 sm:gap-3 whitespace-normal text-center leading-snug" onClick={handleCalendlyClick}>
            <SafeHydrate><Calendar className="w-5 h-5 flex-shrink-0" /></SafeHydrate>
            <span className="block">
              Book Your Free 30-Minute Consultation
            </span>
          </Button>

          <p className="mt-4 text-sm sm:text-base text-muted-dark italic max-w-2xl mx-auto">
            Physician-led care. Secure Texas telemedicine. Treatment only when
            medically appropriate.
          </p>
        </div>
      </div>
    </section>;
}